'use client';

import { SystemIcon } from '@wishket/design-system';

const ScrollTopButton = () => {
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  return (
    <button
      className="box-border flex size-[52px] items-center justify-center rounded-full bg-w-white p-3.5 shadow-graymedium"
      onClick={scrollTop}
    >
      <SystemIcon name="large_top" />
    </button>
  );
};

export default ScrollTopButton;
